import { render, staticRenderFns } from "./modalProformaInvoiceAdd.vue?vue&type=template&id=0c1cabf0&scoped=true"
import script from "./modalProformaInvoiceAdd.vue?vue&type=script&lang=js"
export * from "./modalProformaInvoiceAdd.vue?vue&type=script&lang=js"
import style0 from "./modalProformaInvoiceAdd.vue?vue&type=style&index=0&id=0c1cabf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1cabf0",
  null
  
)

export default component.exports